import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from 'react-collapse';
import { IoIosArrowDown } from "react-icons/io";
import logo_topo from './../../assets/logo-texto-topo.png';
import './styles.css';
var _id = localStorage.getItem("id_agent");

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: "#ffffff"
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(1),
        color: "#184C86"
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    OG_ItemText: {
        marginLeft: -30,
    },
    RI_ItemText: {
        marginLeft: -30,
    },
    PS_ItemText: {
        marginLeft: -30,
    },
    PS_Estudante_ItemText: {
        marginLeft: -30,
    },
    PS_Tutor_ItemText: {
        marginLeft: -30,
    },
    PS_Especialista_ItemText: {
        marginLeft: -30,
    },
    collapsed: {
        paddingLeft: 50
    },
    ListItem: {
        marginLeft: -20
    }
}));

export default function PersistentDrawerLeft() {
    let [organizador, setOrganizador] = useState(false);
    let [RI, setRI] = useState(false);
    let [PS, setPS] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <NavLink to="/"><img id="logo-topo-Side-Nav" src={logo_topo} alt="logo"/></NavLink>
                </Toolbar>
            </AppBar>
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem >
                        <ListItemIcon onClick={() => setOrganizador(!organizador)}>< IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.OG_ItemText} ><NavLink to="/Tela_OG"><p id="Title-Side-Nav-OG">Organizador</p></NavLink></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={organizador} >
                            <ListItem  >
                                <ListItemText><NavLink to="/Tela_Login_Organizador"><p id="screens-Side-Nav-OG">Login</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem  >
                                <ListItemText><NavLink to="/Tela_Consultas"><p id="screens-Side-Nav-OG">Consultas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/Tela_Consulta_Pendente"><p id="screens-Side-Nav-OG">Consultas Pendentes Detalhes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/Tela_Consulta_Encaminhada"><p id="screens-Side-Nav-OG">Consultas Encaminhadas Detalhes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/Tela_Pedidos_de_Inscricao"><p id="screens-Side-Nav-OG">Pedidos de inscrição</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/Tela_Inscricao_Profissional"><p id="screens-Side-Nav-OG">Profissionais da saúde</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/Tela_Pedidos_Instituicoes"><p id="screens-Side-Nav-OG">Instituições</p></NavLink></ListItemText>
                            </ListItem>    
                        </Collapse>
                    </div>
                    <ListItem >
                        <ListItemIcon onClick={() => setRI(!RI)}><IoIosArrowDown id="Arrow-Down-Side_Nav" /> </ListItemIcon>
                        <ListItemText className={classes.RI_ItemText}><NavLink to='/RI'><p id="Title-Side-Nav-RI">Representante de instituição</p></NavLink></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={RI} >
                            <ListItem>
                                <ListItemText><NavLink to="/RI_Login"><p id="screens-Side-Nav-RI">Login</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/RI_Cadastro"><p id="screens-Side-Nav-RI">Cadastro</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/RI_Painel"><p id="screens-Side-Nav-RI">Painel de controle</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to= {{pathname:"/RI_PacientesLista/"+ _id}}><p id="screens-Side-Nav-RI">Lista dos pacientes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to={{pathname:"/RI_PacientesDetalhes/"+ _id}}><p id="screens-Side-Nav-RI">Detalhes dos pacientes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/RI_PacientesCadastro"><p id="screens-Side-Nav-RI">Cadastro dos pacientes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/RI_SolicitarConsulta"><p id="screens-Side-Nav-RI">Marcação de consultas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to={{pathname:"/RI_Consulta/"+_id}}><p id="screens-Side-Nav-RI">Lista de consultas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to={{pathname:"/RI_ConsultasDetalhes/"+ _id}}><p id="screens-Side-Nav-RI">Detalhes de consultas</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>
                    <ListItem >
                        <ListItemIcon onClick={() => setPS(!PS)}><IoIosArrowDown  id="Arrow-Down-Side_Nav"/> </ListItemIcon>
                        <ListItemText className={classes.PS_ItemText}><NavLink to="/Tela_PS"><p id="Title-Side-Nav-PS">Profissional de saúde</p></NavLink></ListItemText>
                    </ListItem>
                    <div className={classes.collapsed}>
                        <Collapse isOpened={PS} >
                            <ListItem>
                                <ListItemText><NavLink to="/login_m"><p id="screens-Side-Nav-PS">Login</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_cadastro"><p id="screens-Side-Nav-PS">Cadastro</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/cad_medico_tutor"><p id="screens-Side-Nav-PS">Cadastro Médico Tutor</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/cad_medico_espec"><p id="screens-Side-Nav-PS">Cadastro Médico Especialista</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/cad_estudante"><p id="screens-Side-Nav-PS">Cadastro Estudante</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.PS_Tutor_ItemText}><NavLink to="/"><p id="Title-Side-Nav-PS-subtitle-Tutor">Médico Tutor</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Consultas Pendentes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Consultas Confirmadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Consultas Passadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Consultas a serem avaliadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Tutor">Con_alRes_Mt</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.PS_Especialista_ItemText}><NavLink to="/tela_ps_painel"><p id="Title-Side-Nav-PS-subtitle-Especialista">Médico Especialista</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_cpe"><p id="screens-Side-Nav-PS-Especialista">Consultas Pendentes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_cc"><p id="screens-Side-Nav-PS-Especialista">Consultas Confirmadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/tela_ps_cpa"><p id="screens-Side-Nav-PS-Especialista">Consultas Passadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.PS_Estudante_ItemText}><NavLink to="/"><p id="Title-Side-Nav-PS-subtitle-Estudante">Estudante</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Estudante">Consultas Pendentes</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Estudante">Consultas Confirmadas</p></NavLink></ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText><NavLink to="/"><p id="screens-Side-Nav-PS-Estudante">Consultas Passadas</p></NavLink></ListItemText>
                            </ListItem>
                        </Collapse>
                    </div>
                </List>
            </Drawer>
        </div>
    );
}
